import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { Storage } from '@ionic/storage-angular';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    public auth: AuthService,
    public router: Router,
    private storage: Storage,
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.auth.isAuthenticated().then((isAuthenticated)=>{
      if (!isAuthenticated) {
        this.router.navigate(['login']);
        return false;   		
      }
      return true;  		
    }); 
  }
  
}
